import type {
    TableProps as _TableProps,
    TableHeadProps as _TableHeadProps,
    TableBodyProps as _TableBodyProps,
    TableFooterProps as _TableFooterProps,
    TableRowProps as _TableRowProps,
    TableColumnHeaderProps as _TableColumnHeaderProps,
    TableCellProps as _TableCellProps,
    TableCaptionProps as _TableCaptionProps,
    TableContainerProps as _TableContainerProps,
} from "@chakra-ui/react";
import {
    forwardRef,
    Table as _Table,
    Thead as _Thead,
    Tbody as _Tbody,
    Tfoot as _Tfoot,
    Tr as _Tr,
    Th as _Th,
    Td as _Td,
    TableCaption as _TableCaption,
    TableContainer as _TableContainer,
} from "@chakra-ui/react";

export interface TableProps extends _TableProps {}
export interface TableHeadProps extends _TableHeadProps {}
export interface TableBodyProps extends _TableBodyProps {}
export interface TableRowProps extends _TableRowProps {}
export interface TableCellProps extends _TableCellProps {}
export interface TableColumnHeaderProps extends _TableColumnHeaderProps {}
export interface TableFooterProps extends _TableFooterProps {}
export interface TableCaptionProps extends _TableCaptionProps {}
export interface TableContainerProps extends _TableContainerProps {}

export const Table = forwardRef<TableProps, "table">(({ ...props }, ref) => (
    <_Table ref={ref} {...props} />
));

export const Thead = forwardRef<TableHeadProps, "thead">(({ ...props }, ref) => (
    <_Thead ref={ref} {...props} />
));

export const Tbody = forwardRef<TableBodyProps, "tbody">(({ ...props }, ref) => (
    <_Tbody ref={ref} {...props} />
));

export const Tfoot = forwardRef<TableFooterProps, "tfoot">(({ ...props }, ref) => (
    <_Tfoot ref={ref} {...props} />
));

export const Tr = forwardRef<TableRowProps, "tr">(({ ...props }, ref) => (
    <_Tr ref={ref} {...props} />
));

export const Th = forwardRef<TableColumnHeaderProps, "th">(({ ...props }, ref) => (
    <_Th ref={ref} {...props} />
));

export const Td = forwardRef<TableColumnHeaderProps, "td">(({ ...props }, ref) => (
    <_Td ref={ref} {...props} />
));

export const TableCaption = forwardRef<TableCaptionProps, "caption">(({ ...props }, ref) => (
    <_TableCaption ref={ref} {...props} />
));

export const TableContainer = forwardRef<TableContainerProps, "div">(({ ...props }, ref) => (
    <_TableContainer ref={ref} {...props} />
));
